import { translatedOptions, visT } from "views/components/visualizations/visualizationTranslation";
import AreaVisualization from "views/components/visualizations/area/AreaVisualization";
import AreaVisualizationConfig from "views/logic/aggregationbuilder/visualizations/AreaVisualizationConfig";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import { DEFAULT_INTERPOLATION, interpolationTypes } from "views/Constants";
import {
  DEFAULT_AXIS_CONFIG,
  axisTypes,
  DEFAULT_AXIS_TYPE
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("vis_validation.area_chart_requires_metric");
const areaChart = {
  type: AreaVisualization.type,
  get displayName() {
    return visT("vis_types.area_chart");
  },
  component: AreaVisualization,
  config: {
    createConfig: () => ({
      interpolation: DEFAULT_INTERPOLATION,
      axisType: DEFAULT_AXIS_TYPE,
      axisConfig: DEFAULT_AXIS_CONFIG
    }),
    fromConfig: (config) => ({
      interpolation: config == null ? void 0 : config.interpolation,
      axisType: config == null ? void 0 : config.axisType,
      ...fromAxisConfig(config)
    }),
    toConfig: (formValues) => AreaVisualizationConfig.create(
      formValues.interpolation,
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "interpolation",
        get title() {
          return visT("vis_common.interpolation");
        },
        type: "select",
        get options() {
          return translatedOptions(interpolationTypes, "vis_common.interpolation_types");
        },
        required: true
      },
      {
        name: "axisType",
        get title() {
          return visT("vis_common.axis_type");
        },
        type: "select",
        get options() {
          return translatedOptions(axisTypes, "vis_common.axis_types");
        },
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default areaChart;
